import { RescomService } from "@app/res-common/services/rescom.service";
import { BehaviorSubject, combineLatest, debounceTime, filter, lastValueFrom } from "rxjs";
import { ReservationApiService } from "../services/reservation-api.service";
import { ReservationService } from "../services/reservation.service";
import { IReservationBkgPromoItemManagePramaters, IReservationPromoApplyPramaters, ResPromoApply, ResPromoSelectSection } from "./res-promo.model";
import { IDynamicApiResponse } from "@app/core/models/dynamic-api-response.model";

export class ResPromoUtility {
    promosParams?: IReservationPromoApplyPramaters
    promos: ResPromoApply[] = [];
    bkgPromosParams?: IReservationPromoApplyPramaters
    bkgPromos: ResPromoApply[] = [];
    promosChanged = new BehaviorSubject(false);
    currentPackageIDForPromo: BehaviorSubject<number | undefined> = new BehaviorSubject<number | undefined>(undefined);

    constructor(
      public reservationService: ReservationService,
      public reservationApiService: ReservationApiService,
      public rescomService: RescomService
    ) {
      combineLatest([
            reservationService.currentCurrency.asObservable(),
            reservationService.currentPriceType.asObservable(),
            reservationService.preBookingUtility.productIDsBS.asObservable(),
            reservationService.currentCruiseSuiteCategory.asObservable(),
            reservationService.currentRequestedPromoIds.asObservable(),
        ]).pipe(
            filter(([currency, priceType]) =>
                currency !== undefined
                && priceType !== undefined
                // &&  voyagesIDs.length !== 0
            ),
            debounceTime(1000)
        ).subscribe({
            next: async ([currency, priceType, voyageIDs, _ ,requestedPromoIds]) => {
                const currencyParam = currency;
                const priceTypeParam = priceType;
                const voyageIDsParam = voyageIDs.toString();
                const pkgID = this.currentPackageIDForPromo.getValue();
                this.getApplyPromo(currencyParam!, priceTypeParam!.PriceTypeID, voyageIDsParam, requestedPromoIds, pkgID);
            }
        })
    }

    checkSameParams(_last:any,_next:any) {
      return false
      // if(!last) return false

      // let equal = true
      // for(var p in last){
      //   if(last.hasOwnProperty(p)){
      //       if(last[p] !== next[p]){
      //         equal = false;
      //         break;
      //       }
      //   }
      // }

      // return equal;
    }
    getApplyPromoPromise(currency: string, pricesTypeId: number, voyageIds:string, requstedPromoIds:number[], packageID?:number):Promise<ResPromoApply[]> {
      const params: IReservationPromoApplyPramaters = {
        Section: ResPromoSelectSection.Inventory,
        CurrencyCod: currency,
        PriceTypeID: pricesTypeId,
        VoyageID: voyageIds,
        PromoID: requstedPromoIds.join(','),
        PackageID: packageID
      }
      if(this.checkSameParams(this.promosParams,params)) return new Promise((resolve,_) => {resolve(this.promos)})
      this.promosParams=params
      return lastValueFrom(this.reservationService.getApplyPromo(params))
    }

    getApplyPromo(currency: string, pricesTypeId: number, voyageIds:string, requstedPromoIds:number[], packageID?:number) {
        const params: IReservationPromoApplyPramaters = {
            Section: ResPromoSelectSection.Inventory,
            CurrencyCod: currency,
            PriceTypeID: pricesTypeId,
            VoyageID: voyageIds,
            PromoID: requstedPromoIds.join(','),
            PackageID: packageID || undefined
        }
        if(this.checkSameParams(this.promosParams,params)) return
        this.promosParams = params
        this.reservationService.getApplyPromo(params).subscribe({
            next: getApplyPromoResponse => {

                const changed = !getApplyPromoResponse.filter(p=>p.isSelected).every(p=> !!this.promos.filter(p=>p.isPreSelect).find(p2=> p.promoID === p2.promoID))
                if(changed) {
                  this.promosChanged.next(true);
                }
                this.promos = getApplyPromoResponse;
            }
        });
    }
    getBookingPromo(bkgID: number) {
      const params: IReservationPromoApplyPramaters = {
          Section: ResPromoSelectSection.Book,
          BkgID: bkgID,
      }
      if(this.checkSameParams(this.bkgPromosParams,params)) return
      this.bkgPromosParams = params
      this.reservationService.getApplyPromo(params).subscribe({
          next: getApplyPromoResponse => {
            const changed = !getApplyPromoResponse.filter(p=>p.isSelected && p.promoTypeID!==2).every(p=> !!this.promos.filter(p=>p.isPreSelect).find(p2=> p.promoID === p2.promoID))
            if(changed) this.promosChanged.next(true);
            this.bkgPromos = getApplyPromoResponse;
          }
      });
  }

  getSelectedPromo() {
    return this.promos.filter(p=>p.promoTypeID!==2 && p.isSelected);
  }
  applyChanges(bkgID:number):Promise<boolean> {

    return new Promise<boolean>((resolve)=>{
      const params:IReservationBkgPromoItemManagePramaters={BkgID:bkgID,Promo:[]};
      this.reservationService.promoUtility
        .bkgPromos
        .filter(p=>p.isSelected!==p.isPreSelect) //Only changed
        .forEach(p=>{
          params.Promo.push({
            PromoID:p.promoID,
            Remove: !p.isSelected && p.isPreSelect ? 'Y' : 'N' //IS REMOVE?
          })
      })

      this.reservationApiService.bkgPromoItemsManage(params).subscribe({
          next: response => {
              resolve(response)
          },
          error: (err: IDynamicApiResponse) => {
            this.rescomService.utilityDialogs.error({
              message: 'Error. Promo Changes failed.',
              error: err?.Errors?.map((e: any) => e.ErrorDesc),
              title: `ERROR ${err?.StatusCod} - ${err?.StatusMessage}`,
              size: '380px',
            });
          },
      });

    });
  }
}
